<template>
 <v-layout v-resize="onResize" column style="padding-top: 56px">
  <v-container>
     <v-overlay
      :opacity="1"
      :value="overlay"
    >
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
    <div class="container-fluid">
      <h3>Registration Tao Yu</h3>
      <v-form lazy-validation ref="formValid" v-model="formValid">
        <div class="row form-group" style="min-height: ">
          <div class="col-md-2">
            <v-avatar
              size="100px"
              v-ripple
              v-if="!url"
              class="grey lighten-3 mb-3"
            >
            </v-avatar>
            <v-avatar size="100px" v-ripple v-else class="mb-3">
              <v-img :src="url"></v-img>
            </v-avatar>
            <!-- <v-img :src="'http://localhost:8000/storage/uploads/profile_photo/v73hxqcvmjU0kcj9y5GcriE9BlcANiM8bah1mpB4.jpg' "></v-img> -->
          </div>
          <div class="col" style="align-content: bottom; display: flex">
            <v-file-input
              @change="Preview_image"
              v-model="formData.url_photo"
              placeholder="Upload Your Photo / Upload Foto (上传照片)"
              style="max-height: 100px"
              class="fileInput"
              id="file"
              :rules="rulesImage"
              ref="file"
            >
            </v-file-input>
          </div>
        </div>
        <div class="row" v-if="shouldRender">
          <div class="form-group col-md">
            <v-select
              :items="listKota"
              label="Registration City / Kota 导引城市"
              required
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              v-model="formData.kota"
              :rules="mandatoryRules"
              :disabled="kotaTaoDisabled"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.identitas"
              label="Identity Number / No. Identitas (身份号码)"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.pinyin"
              label="Chinese Name (Pinyin) / Nama Mandarin 中文名字 (汉语拼音)*"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.nama"
              label="Name 名字*"
              required
              :rules="namaRules"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.hanzi"
              label="Chinese Name (Hànzì) / Nama Mandarin 中文名字 (汉字)*"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-select
              :items="listSuku"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              label="Ethnicity / Suku (民族)"
              required
              v-model="formData.suku"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-select
              :items="listGoldar"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              label="Blood Type / Golongan Darah 血型"
              required
              v-model="formData.goldar"
            ></v-select>
          </div>
        </div>
        <div class="row">Tempat/Tanggal Lahir 出生地/出生日期*</div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.kota_lahir"
              label="Place of Birth / Tempat Lahir 出生地"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
              <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="data_tgl_lahir"
                                label="Date of Birth / Tanggal Lahir 出生日期"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @blur="data_tgl_lahir_raw = parseDate(data_tgl_lahir)"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="data_tgl_lahir_raw"
                            @input="menu2 = false"
                            ></v-date-picker>
                            </v-menu>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-select
              :items="listStatus"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              label="Status 婚姻状况*"
              required
              v-model="formData.status"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <!-- <label for="kelamin">Jenis Kelamin 性別*</label> -->
            <v-radio-group
              label="Gender / Jenis Kelamin 性别*"
              v-model="formData.kelamin"
              mandatory
              column
            >
              <v-radio
                name="formData.kelamin"
                key="L"
                label="Man 男"
                value="L"
              ></v-radio>
              <v-radio
                name="formData.kelamin"
                key="P"
                label="Woman 女"
                value="P"
              ></v-radio>
            </v-radio-group>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.prov_dom"
              label="Residence Province / Provinsi Domisili 居住省"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-select
              :items="listKotaTgl"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              label="Residence City / Kota Domisili 居住市"
              required
              v-model="formData.kota_dom"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.kel_dom"
              label="Residence Village / Kelurahan Domisili 居住村"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.kodepos_dom"
              label="Postal Code / Kode Pos 邮政编码"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.alamat_dom"
              label="Residence Address / Alamat Domisili 住所地址"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.hp"
              label="No Handphone / No. HP 手机号码"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.no_telp"
              label="No Telp 电话号码"
              required
            ></v-text-field>
          </div>
          <!-- <div class="form-group col-md-3">
                            <v-text-field
                                v-model="formData.medsos"
                                label="Social Media / Media sosial 社交媒体"
                                required
                            ></v-text-field>
                        </div>
                        <div class="form-group col-md-3">
                            <v-text-field
                                v-model="formData.user_medsos"
                                label="User Social Media / Pengguna Media Sosial 用户社交媒体"
                                required
                            ></v-text-field>
                        </div> -->
        </div>
        <div class="row">
          <div class="form-group col-md">
            <v-text-field
              v-model="formData.email"
              label="Email 电子邮箱"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-select
              :items="listPendidikan"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              label="Education / Pendidikan 教育程度"
              required
              v-model="formData.pendidikan"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.hobby"
              label="Hobby / Hobi 爱好"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-select
              :items="listPekerjaan"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              label="Occupation / Pekerjaan 职业"
              required
              v-model="formData.job"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.telp_job"
              label="Office Phone Number / Telp. Tempat Kerja 办事处电话"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.address_job"
              label="Office Address / Alamat Tempat Kerja 公司地址"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.motif"
              label="Reason to learn Tao Ying / Motivasi Taoying 导引激励"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-select
              :items="listKotaDaftar"
              item-text="DESKRIPSI_DATA"
              item-value="ID_DATA"
              :disabled="kotaTaoDisabled"
              label="Tao Ying City / Kota Tao Ying 导引城市"
              required
              v-model="formData.kota_tao"
            ></v-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-menu
                                v-model="menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="data_tgl_daftar"
                                    label="Tao Ying Date / Tgl Tao Ying 导引日期"
                                    prepend-icon="mdi-calendar"
                                    :disabled="kotaTaoDisabled"
                                    readonly
                                    v-bind="attrs"
                                    @blur="data_tgl_daftar_raw = parseDate(data_tgl_daftar)"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="data_tgl_daftar_raw"
                                @input="menu3 = false"
                                ></v-date-picker>
                            </v-menu>
          </div>
        </div>
        <div class="row">Referensi oleh</div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.ref_nama"
              label="Name / Nama 名字"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <v-text-field
              v-model="formData.thn_tao"
              :disabled="kotaTaoDisabled"
              label="Year of Tao Ying / Tahun Tao Ying 导引年份"
              required
            ></v-text-field>
          </div>
        </div>
        <div class="row">
         <div class="form-group col">
            <v-btn x-small
              style="margin: 10px; float: left; background-color: #e12b38"
              v-if="this.$session.get('role')!='4'"
              @click="onClose"
              >Close</v-btn
            >
            <v-btn x-small
              style="margin: 10px; float: left; background-color: #fcc133"
              @click="onReset"
              >Clear</v-btn
            >
            <v-btn x-small
              style="margin: 10px; float: left; background-color: #3eb650"
              @click="checkFormValidity('submit')"
              :disabled="disabledSubmit"
              >Submit</v-btn
            >
            <v-btn x-small
              style="margin: 10px; float: left; background-color: #ADD8E6"
              @click="checkFormValidity('save')"
              :disabled="disabledSubmit"
              >Save</v-btn
            >
            <!-- <v-btn style="margin:10px;float:right;background-color: #3EB650"  @click="checkFormValidity">Submit</v-btn> -->
          </div>
        </div>
      </v-form>
    </div>
  </v-container>
</v-layout>
</template>

<script>
import axios from '@/axios'
import 'fix-date'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    name: 'FormDaftarTaoUser',
    components: {
        // FormWizard, TabContent
    },
    watch:{
        data_tgl_daftar_raw (val) {
            this.data_tgl_daftar = this.formatDate(this.data_tgl_daftar_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        data_tgl_lahir_raw (val) {
            this.data_tgl_lahir = this.formatDate(this.data_tgl_lahir_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    props: {
        data: Object,
        dataKota: Object,
        dataTanggal: Object
    },
    // mixins: [ValidationHelper],
    data(){
        return {
            overlay:false,
            disabledSubmit:false,
            formData:{
                url_photo: null,
                negara: null,
                pinyin: null,
                nama: null,
                hanzi: null,
                suku: null,
                goldar: null,
                kota_lahir: null,
                tgl_lahir: '01-01-1900',
                status: null,
                kelamin: null,
                prov_dom: null,
                kota_dom: null,
                kel_dom: null,
                kodepos_dom: null,
                alamat_dom: null,
                hp: null,
                medsos: null,
                user_medsos: null,
                email: null,
                pendidikan: null,
                hobby: null,
                job:null,
                no_telp:null,
                telp_job:null,
                address_job:null,
                motif:null,
                ref_nama:null,
                thn_tao:null,
                kota_tao:null,
                nomor_huangyi:null,//Nomor Huang yi diTaoYu akna kosong
                tgl_daftar:'',
                user_id: this.$session.get('user_id'),
                source:'Taoyu_s',
                foto:null,
                identitas:null,
            },
            shouldRender:false,
            data_tgl_lahir:'',
            data_tgl_lahir_raw:new Date().toISOString().substr(0, 10),
            // data_tgl_daftar:'01-01-1990',
            data_tgl_daftar:'',
            data_tgl_daftar_raw:new Date().toISOString().substr(0, 10),
            listKota:[],
            listKotaDaftar:[],
            listGoldar:[],
            listSuku:[],
            listStatus:[],
            listPendidikan:[],
            listPekerjaan:[],
            listKotaTgl:[],
            kotaTaoDisabled:false,
            // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu2: false,
            menu3: false,
            url:null,
            temp:0,
            photos:null,
            formValid:true,
            role: this.$session.get('role'),
            namaRules: [
                v => !!v || 'Nama wajib di-isi',
                v => (v && v.length >= 3) || 'Nama tidak valid' ,
            ],
            mandatoryRules: [
                v => !!v || 'Data wajib di-isi',
            ],
            rulesImage:[
                v => (v && v.size <=600000) || 'Foto maks 600 KB' ,
            ],
            tahunRules: [
                v => !!v || 'Tahun Tao wajib di-isi',
                v => (v && v.length==4 && /[0-9]*$/.test(v)) || 'Tahun Tao tidak valid',
            ],
        }
    },
    mounted: function (){
        if(this.$session.get('role')=='4'){//Khusus Role User Tao YU
            this.kotaTaoDisabled=false;
            axios({
                method: 'post',
                url: 'taoyu_by_session',
                data: {
                    user_id: this.$session.get('user_id')
                },
                headers: {
                  'Authorization': 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data.length>0){
                    this.data.editedItem=response.data[0];
                    console.log(this.data.editedItem)
                    this.initiateDaftarTao();
                }else{
                    this.initiateDaftarTao();
                }

            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });
        }else{
            this.initiateDaftarTao();
        }
        //Untuk Master Data (axios)
        // alert(JSON.stringify(this.data.editedItem));


    },
    methods:{
       onSave() {
            //Proses pemindahan formdata
            let sendData= new FormData();

            if(this.formData.url_photo){
                sendData.append('foto', this.formData.url_photo);
            }
            // if(this.formData.negara) sendData.append('negara', this.formData.negara);

            if(this.formData.kota) sendData.append('kota', this.formData.kota);
            if(this.formData.url_photo) sendData.append('url_photo', this.formData.url_photo);
            if(this.formData.pinyin) sendData.append('pinyin', this.formData.pinyin);
            if(this.formData.nama) sendData.append('nama', this.formData.nama);
            if(this.formData.hanzi) sendData.append('hanzi', this.formData.hanzi);
            if(this.formData.identitas) sendData.append('no_identitas', this.formData.identitas);
            if(this.formData.suku) sendData.append('suku', this.formData.suku);
            if(this.formData.goldar) sendData.append('goldar', this.formData.goldar);
            if(this.formData.kota_lahir) sendData.append('kota_lahir', this.formData.kota_lahir);
            if(this.formData.status) sendData.append('status', this.formData.status);
            if(this.formData.kelamin) sendData.append('kelamin', this.formData.kelamin);
            if(this.formData.prov_dom) sendData.append('prov_dom', this.formData.prov_dom);
            if(this.formData.kota_dom) sendData.append('kota_dom', this.formData.kota_dom);
            if(this.formData.kel_dom) sendData.append('kel_dom', this.formData.kel_dom);
            if(this.formData.kodepos_dom) sendData.append('kodepos_dom', this.formData.kodepos_dom);
            if(this.formData.alamat_dom) sendData.append('alamat_dom', this.formData.alamat_dom);
            if(this.formData.hp) sendData.append('hp', this.formData.hp);
            if(this.formData.no_telp) sendData.append('no_telp', this.formData.no_telp);
            if(this.formData.medsos) sendData.append('medsos', this.formData.medsos);
            if(this.formData.user_medsos) sendData.append('user_medsos', this.formData.user_medsos);
            if(this.formData.email) sendData.append('email', this.formData.email);
            if(this.formData.pendidikan) sendData.append('pendidikan', this.formData.pendidikan);
            if(this.formData.hobby) sendData.append('hobby', this.formData.hobby);
            if(this.formData.job) sendData.append('job', this.formData.job);
            if(this.formData.telp_job) sendData.append('telp_job', this.formData.telp_job);
            if(this.formData.address_job) sendData.append('address_job', this.formData.address_job);
            if(this.formData.motif) sendData.append('motif', this.formData.motif);
            if(this.formData.ref_nama) sendData.append('ref_nama', this.formData.ref_nama);
            if(this.formData.thn_tao) sendData.append('thn_tao', this.formData.thn_tao);
            if(this.formData.kota_tao) sendData.append('kota_tao', this.formData.kota_tao);
            if(this.formData.nomor_huangyi) sendData.append('nomor_huangyi', this.formData.nomor_huangyi); //
            sendData.append('user_id',this.$session.get('user_id'));
            sendData.append('source', 'Taoyu_s');
            //Huang yi diTaoYu akna kosong

            // if(this.formData.user_id) sendData.append('user_id', this.formData.user_id);
            if(this.formData.user_id) sendData.append('user_id', this.$session.get('user_id'));


            if(this.$session.get('role')=='4'){
                sendData.append('source', 'Taoyu_s');
            }else{
                if(this.data.editedItem.STATUS_ANGGOTA) sendData.append('source', this.data.editedItem.STATUS_ANGGOTA);
            }

            // alert(this.data_tgl_lahir_raw+' '+this.data_tgl_daftar_raw)
            if(this.data_tgl_lahir) sendData.append('tgl_lahir', this.data_tgl_lahir);
            if(this.data_tgl_daftar) sendData.append('tgl_daftar', this.data_tgl_daftar);
            if(typeof(this.data.editedItem.ID_TRX)!=='undefined' && this.data.editedItem.ID_TRX !==null){
                //Edit
                // this.formData.id=this.data.editedItem.ID_TRX;
                sendData.append('id', this.data.editedItem.ID_TRX);
                // alert('Edit');
                axios({
                    method: 'post',
                    url: 'update_data_table_2',
                    data: sendData,
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    
                     Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:'Update Data Sukses!'
                            });
                }).catch(error=>{
                   // console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }else{
                axios({
                    method: 'post',
                    url: 'submit_taoyu',
                    data: sendData,
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {

                    Swal.fire({
                         title:'Peringatan',
                         icon :'success',
                         text:'Sukses!'
                     });
                    this.$router.push({name: 'UserRegis'});
                }).catch(error=>{
                 //   console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }
       },
       onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else
            this.isMobile = false;
        },
        initiateDaftarTao(){
            // console.log('in Form Daftar '+JSON.stringify(this.data.editedItem));
            axios({
                method: 'get',
                url: 'master_data',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {

                this.listKota=response.data.Kota_Daftar;
                this.listKotaDaftar=response.data.Kota_Daftar;
                this.listSuku=response.data.Suku;
                this.listStatus=response.data.Status;
                this.listPendidikan=response.data.Pendidikan;
                this.listPekerjaan=response.data.Pekerjaan;
                this.listGoldar=response.data.Golongan_Darah;
                this.listKotaTgl=response.data.Kota_Domisili;
                // this.users=response.data;
                //Jika Edited


              
               // ypeof this.data.editedItem === 'object' &&
                if(typeof(this.data.editedItem.ID_TRX)!=='undefined' && this.data.editedItem.ID_TRX!==null){//Edited

                    //Form 1
                    if(this.data.editedItem.URL_FOTO){
                        // this.url= 'http://sd6webdev.indomaret.lan/laravel-passport/public/'+'storage/uploads/profile_photo/v73hxqcvmjU0kcj9y5GcriE9BlcANiM8bah1mpB4.jpg';
                        // this.formData.url_photo=this.data.editedItem.URL_FOTO;

                        this.url= 'https://zhengdaolishanghu.com/laravel/'+this.data.editedItem.URL_FOTO;
                        // this.url= URL.createObjectURL('./'+this.formData.url_photo);
                    }

                    // this.formData.kota=this.data.editedItem.ID_KOTA;
                    this.formData.kota = this.listKota.find(item => parseInt(item.ID_DATA) === parseInt(this.data.editedItem.ID_KOTA));
                    if(this.formData.kota!==undefined)
                    {
                        this.formData.kota = this.formData.kota.ID_DATA;
                    }


                    //sini

                    this.formData.pinyin=this.data.editedItem.NAMA_PINYIN;
                    this.formData.hanzi=this.data.editedItem.NAMA_HANZI;
                    this.formData.nama=this.data.editedItem.NAMA_INDO;
                   // console.log(this.data.editedItem.ID_TRX)
                   // console.log(this.formData.nama)
                    this.formData.identitas=this.data.editedItem.NO_IDENTITAS;
                    this.formData.kota_lahir=this.data.editedItem.KOTA_LAHIR;
                    this.formData.kelamin=this.data.editedItem.KELAMIN;

                    this.data_tgl_lahir = new Date(this.data.editedItem.TGL_LAHIR).toLocaleDateString('es-CL');
                    this.data_tgl_lahir_raw = new Date(this.data.editedItem.TGL_LAHIR).toISOString().substr(0, 10);

                    if(this.data.editedItem.ID_STATUS){
                        this.formData.status = this.listStatus.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_STATUS));
                        this.formData.status = this.formData.status.ID_DATA;
                    }

                    if(this.data.editedItem.ID_SUKU){
                        this.formData.suku = this.listSuku.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_SUKU));
                        this.formData.suku = this.formData.suku.ID_DATA;
                    }
                    if(this.data.editedItem.ID_GOLDAR){
                        this.formData.goldar = this.listGoldar.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_GOLDAR));
                        this.formData.goldar = this.formData.goldar.ID_DATA;
                    }
                    if(this.data.editedItem.KOTA_DOM){
                        this.formData.kota_dom = this.listKotaTgl.find(item => item.ID_DATA === parseInt(this.data.editedItem.KOTA_DOM));
                        this.formData.kota_dom = this.formData.kota_dom.ID_DATA;
                    }
                    //Form 2
                    this.formData.prov_dom=this.data.editedItem.PROP_DOM;
                    // this.formData.kota_dom=this.data.editedItem.KOTA_DOM;
                    this.formData.kel_dom=this.data.editedItem.KEL_DOM;
                    this.formData.kodepos_dom=this.data.editedItem.KODE_POS_DOM;
                    this.formData.alamat_dom=this.data.editedItem.ALAMAT_DOM;
                    this.formData.hp=this.data.editedItem.NO_HP;
                    this.formData.med_sos=this.data.editedItem.MED_SOS;
                    this.formData.user_medsos=this.data.editedItem.USER_MEDSOS;
                    this.formData.email=this.data.editedItem.EMAIL;
                    this.formData.hobby=this.data.editedItem.HOBBY;
                    // this.formData.pendidikan =this.data.editedItem.ID_PENDIDIKAN;

                    if(this.data.editedItem.ID_PENDIDIKAN){
                        this.formData.pendidikan = this.listPendidikan.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_PENDIDIKAN));
                        this.formData.pendidikan = this.formData.pendidikan.ID_DATA;
                    }

                    // //Form 3
                    if(this.data.editedItem.ID_PEKERJAAN){
                        this.formData.job = this.listPekerjaan.find(item => item.ID_DATA === parseInt(this.data.editedItem.ID_PEKERJAAN));
                        this.formData.job = this.formData.job.ID_DATA;
                    }
                    this.formData.telp_job=this.data.editedItem.TELP_KERJA;
                    this.formData.address_job=this.data.editedItem.ALAMAT_KERJA;
                    this.formData.no_telp=this.data.editedItem.NO_TELP
                    // //Form 4
                    this.formData.motif=this.data.editedItem.MOTIVASI_TAO;
                    this.formData.ref_nama=this.data.editedItem.REF_NAMA;
                    this.formData.thn_tao=this.data.editedItem.THN_TAOING
                    // this.formData.kota_tao=this.data.editedItem.KOTA_TAOYING;
                    if(this.data.editedItem.KOTA_TAOYING){
                        this.formData.kota_tao = this.listKotaDaftar.find(item => parseInt(item.ID_DATA) === parseInt(this.data.editedItem.KOTA_TAOYING));
                        this.formData.kota_tao = this.formData.kota_tao.ID_DATA;


                    }

                    this.data_tgl_daftar = new Date(this.data.editedItem.TGL_DAFTAR).toLocaleDateString('es-CL');
                    this.data_tgl_daftar_raw = new Date(this.data.editedItem.TGL_DAFTAR).toISOString().substr(0, 10);

                }else if(this.$session.get('role')=='4'){//Khusus Taoyu S

                }else{
                     if(this.dataKota.search_kota){
                        this.formData.kota = this.listKota.find(item => parseInt(item.ID_DATA) === parseInt(this.dataKota.search_kota));
                        this.formData.kota = this.formData.kota.ID_DATA;

                        this.formData.kota_tao = this.listKotaDaftar.find(item => parseInt(item.ID_DATA) === parseInt(this.dataKota.search_kota));
                        this.formData.kota_tao = this.formData.kota_tao.ID_DATA;
                        this.temp=this.dataKota.search_kota


                    }

                    if(this.dataTanggal.search_tgl_daftar_raw){
                        //Cant Use the function (Probably, still doesn't deifned on this function)

                        // this.data_tgl_daftar = new Date(this.dataTanggal.search_tgl_daftar_raw).toLocaleDateString('es-CL');
                        // this.data_tgl_daftar_raw = new Date(this.dataTanggal.search_tgl_daftar_raw).toLocaleDateString('sv-SE');



                    }
                    this.formData={
                        url_photo: null,
                        thn_tao: null,
                        kota_tao:this.temp,
                        negara: null,
                        pinyin: null,
                        nama: null,
                        hanzi: null,
                        suku: null,
                        goldar: null,
                        kota_lahir: null,
                        tgl_lahir: '01-01-1900',
                        status: null,
                        kelamin: null,
                        prov_dom: null,
                        kota_dom: null,
                        kel_dom: null,
                        kodepos_dom: null,
                        alamat_dom: null,
                        hp: null,
                        medsos: null,
                        user_medsos: null,
                        email: null,
                        pendidikan: null,
                        hobby: null,
                        job:null,
                        no_telp:null,
                        telp_job:null,
                        address_job:null,
                        motif:null,
                        ref_nama:null,
                        nomor_huangyi:null,
                        user_id: this.$session.get('user_id'),
                        source:'Taoyu_s',
                        foto:null,
                        identitas:null,
                    }
                    console.log(this.formData)
                }


            }).catch(error=>{
                  Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Failed to retrieve data !'
                        });

                  console.log(error)
                // alert('Failed to retrieve data !'+JSON.stringify(error));
                // this.$emit('onCloseDialog');
                // var status = error.response.status
            });
            // console.log(this.data.editedItem);
        },
        formatDate (val) {
            if (!val) 
            {
                return null
            }else{
                return new Date(val).toLocaleDateString('es-CL');

            }
        },
        parseDate (val) {
            if(val!==null && typeof(val)!=='undefined'){ 
                return new Date(val).toISOString().substr(0, 10)
            }else{
                return null
            } 
            
        },
        onChangeKota(){

        },
        // checkFormValidity(){
        //     this.formValid=false;
        //     //Check Validity (Kolom yang mandatory, dan Nomor Huang Yi)
        //     if(this.formData.nama && this.formData.kota_tao && this.formData.hp && this.$refs.file.size <=600000){
        //          this.onSubmit();
        //          this.formValid=true;
        //     }else{
        //         if(!this.formData.nama)
        //         {
        //              Swal.fire({
        //                         title:'Peringatan',
        //                         icon :'error',
        //                         text:'Name is not valid'
        //                 });
        //         }else if(!this.formData.kota_tao){
        //              Swal.fire({
        //                         title:'Peringatan',
        //                         icon :'error',
        //                         text:'City/Tao Ying City is not valid'
        //                 });
        //          }else if(!this.formData.hp){
        //             Swal.fire({
        //                         title:'Peringatan',
        //                         icon :'error',
        //                         text:'The Phone Number is not valid'
        //                 });
        //         }else{
        //           Swal.fire({
        //                         title:'Peringatan',
        //                         icon :'error',
        //                         text:'Photo is not valid'
        //                 });

        //         }
        //          this.formValid=false;
                
        //     }

        // },
         checkFormValidity(choice){
            this.formValid=false;
            //Check Validity (Kolom yang mandatory, dan Nomor Huang Yi)
            if(this.formData.url_photo !== null && this.$refs.file.validate() === false){
                Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Photo is not valid'
                        });
            }else if(this.formData.nama && this.formData.kota_tao && this.formData.hp && choice==='submit'){
                 this.onSubmit();
                 this.formValid=true;
            }else if(this.formData.nama && this.formData.kota_tao && this.formData.hp && choice==='save'){
                 this.onSave();
                 this.formValid=true;
            }else{
                if(!this.formData.nama)
                {
                     Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Name is not valid'
                        });
                }else if(!this.formData.kota_tao){
                     Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'City/Tao Ying City is not valid'
                        });
                 }else if(!this.formData.hp){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'The Phone Number is not valid'
                        });
                }
                 this.formValid=false;
                
            }

        },
        onSubmit(){
            this.disabledSubmit=true
            this.$nextTick(() => {
                      // this.editedItem = Object.assign({}, this.defaultItem)
                      this.overlay=true
                      })
            //Proses pemindahan formdata
            let sendData= new FormData();

            if(this.formData.url_photo){
                sendData.append('foto', this.formData.url_photo);
            }
            // if(this.formData.negara) sendData.append('negara', this.formData.negara);

            if(this.formData.kota) sendData.append('kota', this.formData.kota);
            if(this.formData.url_photo) sendData.append('url_photo', this.formData.url_photo);
            if(this.formData.pinyin) sendData.append('pinyin', this.formData.pinyin);
            if(this.formData.nama) sendData.append('nama', this.formData.nama);
            if(this.formData.hanzi) sendData.append('hanzi', this.formData.hanzi);
            if(this.formData.identitas) sendData.append('no_identitas', this.formData.identitas);
            if(this.formData.suku) sendData.append('suku', this.formData.suku);
            if(this.formData.goldar) sendData.append('goldar', this.formData.goldar);
            if(this.formData.kota_lahir) sendData.append('kota_lahir', this.formData.kota_lahir);
            if(this.formData.status) sendData.append('status', this.formData.status);
            if(this.formData.kelamin) sendData.append('kelamin', this.formData.kelamin);
            if(this.formData.prov_dom) sendData.append('prov_dom', this.formData.prov_dom);
            if(this.formData.kota_dom) sendData.append('kota_dom', this.formData.kota_dom);
            if(this.formData.kel_dom) sendData.append('kel_dom', this.formData.kel_dom);
            if(this.formData.kodepos_dom) sendData.append('kodepos_dom', this.formData.kodepos_dom);
            if(this.formData.alamat_dom) sendData.append('alamat_dom', this.formData.alamat_dom);
            if(this.formData.hp) sendData.append('hp', this.formData.hp);
            if(this.formData.no_telp) sendData.append('no_telp', this.formData.no_telp);
            if(this.formData.medsos) sendData.append('medsos', this.formData.medsos);
            if(this.formData.user_medsos) sendData.append('user_medsos', this.formData.user_medsos);
            if(this.formData.email) sendData.append('email', this.formData.email);
            if(this.formData.pendidikan) sendData.append('pendidikan', this.formData.pendidikan);
            if(this.formData.hobby) sendData.append('hobby', this.formData.hobby);
            if(this.formData.job) sendData.append('job', this.formData.job);
            if(this.formData.telp_job) sendData.append('telp_job', this.formData.telp_job);
            if(this.formData.address_job) sendData.append('address_job', this.formData.address_job);
            if(this.formData.motif) sendData.append('motif', this.formData.motif);
            if(this.formData.ref_nama) sendData.append('ref_nama', this.formData.ref_nama);
            if(this.formData.thn_tao) sendData.append('thn_tao', this.formData.thn_tao);
            if(this.formData.kota_tao) sendData.append('kota_tao', this.formData.kota_tao);
            if(this.formData.nomor_huangyi) sendData.append('nomor_huangyi', this.formData.nomor_huangyi); //
            sendData.append('user_id',this.$session.get('user_id'));
            sendData.append('source', 'Taoyu_s');
            //Huang yi diTaoYu akna kosong

            // if(this.formData.user_id) sendData.append('user_id', this.formData.user_id);
            if(this.formData.user_id) sendData.append('user_id', this.$session.get('user_id'));


            if(this.$session.get('role')=='4'){
                sendData.append('source', 'Taoyu_s');
            }else{
                if(this.data.editedItem.STATUS_ANGGOTA) sendData.append('source', this.data.editedItem.STATUS_ANGGOTA);
            }

            // alert(this.data_tgl_lahir_raw+' '+this.data_tgl_daftar_raw)
            if(this.data_tgl_lahir) sendData.append('tgl_lahir', this.data_tgl_lahir);
            if(this.data_tgl_daftar) sendData.append('tgl_daftar', this.data_tgl_daftar);

            if(typeof(this.data.editedItem.ID_TRX)!=='undefined' && this.data.editedItem.ID_TRX !==null){
                //Edit
                // this.formData.id=this.data.editedItem.ID_TRX;
                sendData.append('id', this.data.editedItem.ID_TRX);
                // alert('Edit');
                axios({
                    method: 'post',
                    url: 'update_data_table_2',
                    data: sendData,
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    
                     Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data+'.\nYou will be logout automatically.'
                            });
                    this.printProfile(this.data.editedItem.ID_TRX,this.formData.nama)
                }).catch(error=>{
                   // console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }else if(this.$session.get('role')!='4'){//New non Taoyu
                // alert('New');
                //Insert new
                axios({
                    method: 'post',
                    url: 'data_table',
                    data: sendData,
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                     
                      
                     Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data+'.\nYou will be logout automatically.'
                            });
                    this.printProfile(response.data.id,this.formData.nama)
                   
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }else if(this.$session.get('role')==='4'){//New Taoyu
                axios({
                    method: 'post',
                    url: 'submit_taoyu',
                    data: sendData,
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                  
                    this.printProfile(response.data.id,this.formData.nama)
                    
                }).catch(error=>{
                 //   console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }

        },
        printProfile(id_trx,nama_indo){

            this.dialogLoading=true;
            this.dialogLoading=false;
            const swalWithBootstrapButtons = Swal.mixin({
                                              customClass: {
                                                confirmButton: 'btn btn-success',
                                                cancelButton: 'btn btn-danger'
                                              },
                                              buttonsStyling: false
                                            })

            swalWithBootstrapButtons.fire({
             // title: 'Are you sure?',
              text: "Are you sure?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, download pdf!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                axios({
                    method: 'post',
                    url: 'profile_data',
                    responseType: 'blob', // important
                    data:{
                        id: id_trx
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    // console.log(response);
                    if(response){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nama_indo+'.pdf');
                        document.body.appendChild(link);
                        link.click();
                        this.dialogLoading=false;

                      
                        this.$nextTick(() => {
                        // this.editedItem = Object.assign({}, this.defaultItem)
                          this.overlay=false
                        })
                        // this.initialize();
                        if(this.$session.get('role')==='4')
                        {
                           Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:'\nYou will be logout automatically.\nThank you for the registration.'
                            });
                    
                            axios({
                                    method: 'post',
                                    url: 'update_user_flag',
                                    data:{
                                        id: this.$session.get('user_id')
                                    },
                                    headers: {
                                      Authorization: 'Bearer ' + this.$session.get('token'),
                                    },
                                }).then(response => {
                                  this.authenticated = false;
                                  this.$session.destroy();
                                  this.$router.push('/');
                                }).catch(error => {

                                });
                        }
                    }
                }).catch(error => {
                    this.dialogLoading=false;
                    console.log(error.response);
                });
              } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
              ) {
                alert('sini')
                swalWithBootstrapButtons.fire(
                  'Cancelled',
                  'It is okay :)',
                  'info'
                )
                 this.dialogLoading=false;
              }
            })

        },
        onClose(){
            this.onReset();
            this.data.editedItem.ID_TRX=null
            this.$emit('onCloseDialog');
        },
        onReset(){
            this.formData.url_photo=null;
            this.formData.negara=null;
            this.formData.pinyin=null;
            this.formData.nama=null;
            this.formData.hanzi=null;
            this.formData.identitas=null;
            this.formData.suku=null;
            this.formData.goldar=null;
            this.formData.kota_lahir=null;
            this.formData.tgl_lahir='1900-01-01';
            this.formData.status=null;
            this.formData.kelamin=null;
            this.formData.prov_dom= null;
            this.formData.kota_dom= null;
            this.formData.kel_dom= null;
            this.formData.kodepos_dom= null;
            this.formData.alamat_dom= null;
            this.formData.hp= null;
            this.formData.no_telp=null;
            this.formData.medsos= null;
            this.formData.email= null;
            this.formData.pendidikan= null;
            this.formData.hobby= null;
            this.formData.job=null;
            this.formData.telp_job=null;
            this.formData.address_job=null;
            this.formData.motif=null;
            this.formData.ref_nama=null;
            this.formData.thn_tao=null;
            this.formData.kota_tao=null;
            this.formData.tgl_daftar='1900-01-01';
            this.formData.created_by= this.$session.get('user_id');
        },
        Preview_image(event) {
          // this.photos= event.target.files[0];
          // console.log(this.formData.url_photo);
          // alert(this.formData.url_photo);
          // alert(this.formData.url_photo.substring(0,3));
          // if(this.formData.url_photo.substring(0,3)=='http'){
          //   this.url= this.formData.url_photo;
          // }else if(this.formData.url_photo){
          // }

            this.url= URL.createObjectURL(this.formData.url_photo);
        }
    }
}
</script>


<style type="text/css">
.fileInput {
  align-self: flex-end;
}

.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>


